/**
 * A short sound when a sheet finishes (SLD-0006). The solver takes 20-35 s,
 * and the operator spends it at the printer rather than watching the screen.
 *
 * Made with Web Audio rather than a sound file: two notes need no asset and
 * nothing to load. Browsers play sound only once the person has used the page,
 * which pressing the shoot button already is.
 */

const SOUND_KEY = 'stitch-lane.sound';

// A per-workstation preference, so localStorage; it may be unavailable.
export function soundOn(): boolean {
  try { return localStorage.getItem(SOUND_KEY) !== 'off'; } catch { return true; }
}
export function setSoundOn(on: boolean) {
  try { localStorage.setItem(SOUND_KEY, on ? 'on' : 'off'); } catch { /* this visit only */ }
}

let context: AudioContext | null = null;

/** Rising for ready to review, falling for refused. */
export function chime(kind: 'ready' | 'refused'): void {
  if (!soundOn()) return;
  try {
    context ??= new AudioContext();
    const ctx = context;
    void ctx.resume();
    const notes = kind === 'ready' ? [660, 880] : [440, 330];
    notes.forEach((hz, i) => {
      const start = ctx.currentTime + i * 0.18;
      const tone = ctx.createOscillator();
      const gain = ctx.createGain();
      tone.frequency.value = hz;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.3, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.3);
      tone.connect(gain).connect(ctx.destination);
      tone.start(start);
      tone.stop(start + 0.32);
    });
  } catch { /* no sound is not a fault */ }
}
